'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWrapText = function MdWrapText(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 18.4c3.6 0 6.6 2.9 6.6 6.6s-3 6.6-6.6 6.6h-3.4v3.4l-5-5 5-5v3.4h3.8c1.7 0 3.3-1.6 3.3-3.4s-1.6-3.4-3.3-3.4h-22.2v-3.2h21.8z m5-10v3.2h-26.8v-3.2h26.8z m-26.8 23.2v-3.2h10v3.2h-10z' })
        )
    );
};

exports.default = MdWrapText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wrap-text.js
// module id = 3475
// module chunks = 0